<template>
  <div class='h-dialogContainer'>
    <div class='h-subscriber-inputLit'>{{$t('SubscriberIms.staffId')}}:</div>
    <ejs-textbox :value='obj.staffnum' v-model='obj.staffnum'></ejs-textbox>
    <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.staffName')}}:</div>
    <ejs-textbox :value='obj.staffname' v-model='obj.staffname'></ejs-textbox>
    <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.userNo')}}:</div>
    <ejs-textbox :value='obj.udn' v-model='obj.udn'></ejs-textbox>   
  </div>
</template>

<script>
export default {
  name: 'ImsInfoSearchDialog',
  props: [
  ],
  data() {
    return { 
      obj: {
        staffnum: '',
        staffname: '',
        udn: '',
        flag: 2,
      }
    };
  },
  methods: {
    getFormValue() {
      return { staffnum: this.obj.staffnum, staffname: this.obj.staffname, udn: this.obj.udn, flag: 2 };
    },
    getDatas() {
      return this.obj;
    },
    setData(data) {
      if (data) {
        this.obj = data;
      }
    }
  }
};
</script>

<style scoped>

</style>
